import { useEventListener, useSupported } from "@vueuse/core";

const LOCATION_ENABLED_EVENT = "location-enabled";

// LocationPermissionButton announces when the user allows location from it, so pages that gave up after a
// denial can ask again.
export function announceLocationEnabled(position) {
  window.dispatchEvent(new CustomEvent(LOCATION_ENABLED_EVENT, { detail: position }));
}

export function onLocationEnabled(callback) {
  useEventListener(LOCATION_ENABLED_EVENT, callback);
}

// whether the browser has the <geolocation> element (Chrome 144+); false during SSR and hydration
export function useGeolocationElementSupport() {
  return useSupported(() => "HTMLGeolocationElement" in window);
}
